<template>
  <b-container fluid>
    <b-row>
      <b-col class="d-flex">
        <backlink class="mt-20" />
        <div class="flex-grow-1">
          <h1>
            Feuille d'expédition
            <div v-if="!isBusy && form.shipping_number" class="subtitle">#{{ form.shipping_number }}</div>
          </h1>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "ShippingMobileForm",
  components: {
    AdminForm
  },
  data() {
    return {
      config: config,
      form: {
        warehouse_id: null,
        shipper_id: null,
        status_slug: null,
        imputation_number: null,
        shipping_date: this.$moment().format("YYYY-MM-DD"),
      },
      isBusy: false
    };
  },
  computed: {
    options: function() {
      return {
        shipper_id_options: this.$store.getters["company/getByTypeCode"](
          "TRSP"
        ).selectOptions("id", "name"),
        status_slug_options: this.$store.getters["status/getByGroup"](
          "shipping"
        ).selectOptions("status_slug", "name")
      };
    }
  },
  mounted() {
    // Edition
    const id = this.$route.params.id;

    // Dans le cas ou on vient d'une préparation, on change la route de la liste dans la config
    // afin que AdminForm nous y renvoie ensuite
    if (
      this.$route.name == "ShippingMobileEditReferer" &&
      this.$route.params.referer &&
      this.$route.params.referer == "renting_preparation"
    ) {
      this.config.redirectAfterEditRouteName = "RentingPreparationMobileList";
    }

    if (id) {
      // Chargement du numéro d'imputation par défaut
      let defaultInputationNumber = this.$store.getters[
        "myaxiloc_setting/getSetting"
      ]("imputation-number");

      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true
        })
        .then(() => {
          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item,
            warehouse_id: item.warehouse ? item.warehouse.id : null,
            renting_preparation_id: item.renting_preparation
              ? item.renting_preparation.id
              : null,
            shipper_id: item.shipper ? item.shipper.id : null,
            status_slug: item.status ? item.status.status_slug : null,
            shipping_date: item.shipping_date
              ? this.$moment(item.shipping_date).format("YYYY-MM-DD")
              : this.$moment().format("YYYY-MM-DD"),
            imputation_number:
              item.imputation_number || defaultInputationNumber.value
          };
          this.isBusy = false;
        });
    }

    this.$store.dispatch("company/getAllForSelect");
  }
};
</script>

<style lang="scss">
.wrapper-content {
  margin-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/ShippingMobile/ShippingMobileForm.vue